import React from "react";

import { GetDigest } from "data/libs/hubs";

import { useFeatures } from "../FeatureFlag";
import HubDigest from "./HubDigest";

function Digest(props) {
  const { legacy, minNumOfTasks } = useFeatures(
    "digest-completed-tasks-across-hubs-experiments",
    { legacy: true, minNumOfTasks: 1 }
  );

  const getDigest = (id, s, e) => {
    return GetDigest(id, s, e, legacy, minNumOfTasks);
  };

  return <HubDigest getDigest={getDigest} {...props} />;
}

export default Digest;
